import { cnMixSpace, Text } from 'uikit';

import type { PropsWithChildren } from 'react';
import React from 'react';

export const GroupHeader = ({ children, mB }: PropsWithChildren<{ mB?: any }>) => (
    <Text size="m" className={cnMixSpace({ mB: mB || 'm' })}>
        {children}
    </Text>
);

GroupHeader.displayName = 'GroupHeader';
